import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Loadspinner from '../../common/Loadspinner';
import Main from '../../common/Main/Main';
import { downloadBlob } from '../../services/CommonService';
import EventsGalleryService from '../../services/EventsGalleryService';
import ImageLightBox from "./ImageLightBox";
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Link } from "react-router-dom";
import useKeyPress from './useKeyPress';
import { Modal } from '@mui/material';
import { APICall } from '../../helpers/API/APICalls';
import { getEventGalleryById } from '../../constants/ApiEndpoints';
import { Card } from 'react-bootstrap';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';
import { ic_broken_image } from '../../constants/Images';
import CancelButton from "../../ReusableComponents/Buttons/CancelButton/CancelButton";
import { useHistory } from "react-router-dom";
import { replaceImgAccountName } from '../../helpers/Utils/Utils';

const ViewMoreImage2 = () => {
    const { id: galleryId } = useParams();
    const [loading, setLoading] = useState(false);
    const [imageUrls, setImageUrls] = useState([]);
    const [isViewerOpen, setIsViewerOpen] = useState(false);
    const [imageData, setImageData] = useState([]);
    const [currentImageIndex, setCurrentImageIndex] = useState('');
    const [currentImageUrl, setCurrentImageUrl] = useState('');
    const [currentImageData, setCurrentImageData] = useState(null);
    const rightPress = useKeyPress("ArrowRight");
    const leftPress = useKeyPress("ArrowLeft");
    let history = useHistory();

    const openImageViewer = async (index) => {
        setCurrentImageIndex(index);
        setCurrentImageData(imageData?.[index]);
        const img = imageUrls?.[index];
        if (img) {
            const buildFullImageUrl = img; //await downloadBlob(img);
            setCurrentImageUrl(buildFullImageUrl);
            setIsViewerOpen(true)
        }
    }

    const getEventGalleriesV2 = async () => {
        let requestParams = {
            id: galleryId
        };
        //console.log(requestParams);
        let res = await APICall(getEventGalleryById, requestParams);
        if (res.message === "Ok") {
            if (res && res.data.length > 0) {
                setImageData(res.data);
                let imgList = [];
                for (let index = 0; index < res?.data?.length; index++) {
                    const imgObj = res?.data?.[index];

                    imgList.push(await downloadBlob(replaceImgAccountName(imgObj.docUrl)));
                }
                setImageUrls(imgList);
            } else {
                setImageUrls([]);
                setImageData([]);
            }
        } else {
            setImageUrls([]);
            setImageData([]);
        }
    }

    useEffect(() => {
        getEventGalleriesV2()
    }, [])

    useEffect(() => {
        isViewerOpen && rightPress && currentImageIndex < imageUrls?.[currentImageIndex]?.length - 1 && openNextImage()
    }, [rightPress]);

    useEffect(() => {
        isViewerOpen && leftPress && currentImageIndex > 0 && openPrevImage()


    }, [leftPress]);


    const openNextImage = async () => {
        const nextIndex = currentImageIndex + 1;
        setCurrentImageIndex(prevCount => prevCount + 1);
        setCurrentImageData(imageData?.[nextIndex]);

        const imgUrl = imageUrls?.[nextIndex];
        if (imgUrl) {
            const buildImageUrl = imgUrl; //await downloadBlob(imgUrl);
            setCurrentImageUrl(buildImageUrl);
        }
    }
    const openPrevImage = async () => {
        const prevIndex = currentImageIndex - 1;
        setCurrentImageIndex(prevCount => prevCount - 1);
        setCurrentImageData(imageData?.[prevIndex]);

        const imgUrl = imageUrls?.[prevIndex];
        if (imgUrl) {
            const buildImageUrl = imgUrl; //await downloadBlob(imgUrl);
            setCurrentImageUrl(buildImageUrl);
        }
    }


    return (
        <>
            <Main active={"eventgallery"}>
                <Loadspinner filename="ViewMoreImage2.js" isLoading={loading} isMiddle="false" />
                <h5 style={{ marginBottom: "15px", marginTop: '15px', marginLeft: "10px" }}
                    onClick={() => { history.push({ pathname: "/eventgallery" }) }}>
                    <i class="fa fa-arrow-circle-left"></i> Event Gallery</h5>
                <div style={{ marginBottom: '50px' }}>

                    <div className="container-fluid">
                        <div className='row'>
                            {
                                imageUrls.map((item, itemIndex) => {
                                    let extraCol = null;
                                    const imgObj = imageData?.[itemIndex];
                                    let imgView = (
                                        // <div className='col-lg-3 col-sm-3 col-xs-3' key={`key_${itemIndex}`}>
                                        //     <span style={{ fontWeight: '500' }}>{item.Name}</span>
                                        //     <div className="eventGallery">

                                        //         <img src={item} key={`key_${itemIndex}`} style={{ width: '200px', cursor: 'pointer' }} onClick={() => openImageViewer(itemIndex)} />
                                        //     </div>
                                        // </div>
                                        <Card key={`key_${itemIndex}`} className="col-lg-2 col-sm-2 col-xs-2 imgCard" onClick={() => openImageViewer(itemIndex)}>
                                            {
                                                //file.type.startsWith('video') ?
                                                imgObj?.docExtension?.startsWith('video') ?
                                                    <video src={item} className="gridImage" /> :
                                                    <Card.Img
                                                        variant="top"
                                                        src={item}
                                                        className="gridImage"
                                                        onError={({ currentTarget }) => {
                                                            currentTarget.onerror = null; // prevents looping
                                                            currentTarget.src = ic_broken_image;
                                                        }}
                                                    />
                                            }
                                        </Card>


                                    )
                                    // if ((itemIndex + 1) % 3 === 0) {
                                    //     extraCol = <div className='col-lg-3 col-sm-3 col-xs-3'/>
                                    // }

                                    return [imgView, extraCol];
                                })
                            }

                        </div>


                    </div>

                </div>

            </Main>
            <Modal
                open={isViewerOpen}
                onClose={setIsViewerOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backgroundColor: 'rgba(0, 0, 0, 0.9)' }}
            >
                <div className="modal-parent-div">
                    <div onClick={() => setIsViewerOpen(false)} style={{
                        position: 'absolute',
                        top: 10,
                        right: 10,
                        zIndex: 100,
                        cursor: 'pointer',
                        color: 'whitesmoke'
                    }}><CloseIcon /></div>
                    {currentImageData?.docExtension?.startsWith('video') ?
                        <video src={currentImageUrl} className="fullscreenVideo" controls /> :
                        <img src={currentImageUrl}
                            alt="image"
                            style={{
                                height: '94vh',
                                width: 'auto',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                display: 'block',
                                marginTop: '40px'
                            }}
                            onError={({ currentTarget }) => {
                                currentTarget.onerror = null; // prevents looping
                                currentTarget.src = ic_broken_image;
                            }}
                        />
                    }
                    {currentImageIndex < imageUrls?.length - 1 &&

                        <div onClick={openNextImage} style={{
                            position: 'absolute',
                            top: '50%',
                            right: 10,
                            zIndex: 100,
                            cursor: 'pointer',
                            color: 'whitesmoke'
                        }}><ArrowForwardIosIcon /></div>}

                    {currentImageIndex > 0 && <div onClick={openPrevImage} style={{
                        position: 'absolute',
                        top: '50%',
                        left: 10,
                        zIndex: 100,
                        cursor: 'pointer',
                        color: 'whitesmoke'
                    }}><ArrowBackIosNewIcon /></div>}
                </div>
            </Modal>
        </>
    )
}

export default ViewMoreImage2